import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrokerComponent } from './broker.component';
import { SharedModule } from '../../shared/shared.module';
import { ListGridModule } from '../../shared/listGrid/listGrid.module';

@NgModule({
  imports: [CommonModule, SharedModule, ListGridModule],
  declarations: [BrokerComponent],
})
export class BrokerModule {}
